/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import $ from 'jquery';
import 'bootstrap';
import '@grubersjoe/slide-menu/dist/slide-menu.ie';
import 'tiny-slider/src/tiny-slider';
import '@wavenet/cookie-law';
import 'react-datepicker/dist/react-datepicker.css';
import 'tiny-slider/dist/tiny-slider.css';

import './HomePageResponsive';
import './design';
import './contentPageMenu';
import './DisplayMore';
import './Widgets/NewsLetter';
import './Widgets/Employers';
import './Widgets/Event';
import './Widgets/Multimedia';
import './Widgets/Prime';
import './Widgets';
import './Helpers';
import './DexieDB';
import './CaptchaBootstrap';

const win: any = window;
win.jQuery = win.$ = $;
